export default "__VITE_ASSET__CqN$jbDU__"